module.exports = __webpack_public_path__ + "static/pic8-e77d03ce5039b0cb19369a769f78e163.png";